export const translations = {
  es: {
    hero: {
      title: 'Sobre',
      subtitle: 'Cortex AI',
      description: 'Impulsando carreras, construyendo negocios y transformando el aprendizaje a través de la mentoría con IA.'
    },
    welcome: {
      title: 'Bienvenido a Cortex AI',
      subtitle: 'La primera plataforma de mentoría impulsada por IA del mundo',
      description: 'En Cortex AI, creemos que el aprendizaje debe ser más que solo ver videos o leer teoría—debe sentirse como una experiencia laboral real, preparándote para roles de trabajo reales y éxito empresarial.',
      features: [
        'Mentoría profesional impulsada por IA – Aprende directamente de un mentor interactivo de IA que te guía como un jefe o coach real.',
        'Desafíos del mundo real y escenarios de toma de decisiones – Obtén experiencia práctica a través de simulaciones impulsadas por IA de situaciones laborales reales.',
        'Apoyo para la creación de negocios – Desde ideas de startups hasta tiendas de comercio electrónico, nuestro mentor de IA ayuda a los emprendedores a lanzar y escalar sus negocios.',
        'Aprendizaje gamificado e interactivo – ¡No más cursos aburridos! Gana XP, insignias y logros del mundo real a medida que progresas.'
      ]
    },
    mission: {
      title: 'Nuestra Misión',
      subtitle: 'Cerrar la brecha entre el aprendizaje y el éxito en el mundo real',
      features: [
        {
          title: 'Mentoría IA Personalizada',
          description: 'Aprende directamente de un mentor interactivo de IA que te guía como un jefe o coach real.'
        },
        {
          title: 'Desafíos del Mundo Real',
          description: 'Enfrenta desafíos y escenarios del mundo real que replican situaciones laborales auténticas en tu campo profesional o emprendimiento.'
        },
        {
          title: 'Feedback Detallado',
          description: 'Recibe análisis detallados de tu desempeño con recomendaciones específicas para mejorar tus habilidades profesionales y empresariales.'
        }
      ]
    },
    founder: {
      title: 'Conoce al Fundador y CEO',
      name: 'Alexis Zamora',
      role: 'Fundador y CEO',
      description: 'Alexis Zamora, el Fundador y CEO de Cortex AI, es un líder visionario en educación impulsada por IA e innovación empresarial.',
      experience: 'Con más de 15 años de experiencia en operaciones de TI, computación en la nube, automatización con IA y desarrollo de procesos de negocio, Alexis ha liderado proyectos multimillonarios en sectores como seguros, banca, gobierno y gestión de activos.',
      vision: {
        title: '¿Por qué se creó Cortex AI?',
        description: 'Alexis vio un problema importante en la industria de la educación y la formación profesional:',
        problems: [
          'Los cursos en línea enseñan teoría, pero no preparan a las personas para trabajos reales.',
          'Los emprendedores carecen de orientación paso a paso sobre cómo lanzar y escalar un negocio.',
          'Los solicitantes de empleo luchan por obtener experiencia del mundo real para conseguir roles bien remunerados.'
        ]
      },
      quote: '"Quería construir una plataforma donde las personas no solo aprendan, sino que realmente experimenten lo que es ser un Product Manager, un Emprendedor o un Dueño de Negocio. Cortex AI proporciona mentoría del mundo real a escala, haciendo que el crecimiento profesional sea más accesible para todos."'
    },
    contact: {
      title: 'Contacta con nosotros',
      sections: {
        support: {
          title: 'Soporte',
          email: 'soporte@cortex-ai.es',
          phone: '+34 91 123 45 67'
        },
        sales: {
          title: 'Ventas',
          email: 'ventas@cortex-ai.es',
          phone: '+34 91 123 45 68'
        },
        press: {
          title: 'Prensa',
          email: 'prensa@cortex-ai.es',
          phone: '+34 91 123 45 69'
        },
        headquarters: {
          title: 'Oficina central',
          address: ['Calle Gran Vía, 28', '28013 Madrid, España']
        }
      }
    },
    locations: {
      title: 'Ubicaciones',
      offices: {
        madrid: {
          city: 'Madrid',
          address: ['Calle Gran Vía, 28', '28013 Madrid, España']
        },
        barcelona: {
          city: 'Barcelona',
          address: ['Passeig de Gràcia, 43', '08007 Barcelona, España']
        },
        valencia: {
          city: 'Valencia',
          address: ['Carrer de Colón, 22', '46004 Valencia, España']
        },
        sevilla: {
          city: 'Sevilla',
          address: ['Avenida de la Constitución, 15', '41004 Sevilla, España']
        }
      }
    },
    cta: {
      title: '¿Listo para transformar tu carrera?',
      subtitle: 'Comienza tu viaje con Cortex AI hoy.',
      buttons: {
        start: 'Empezar gratis',
        sales: 'Contactar ventas'
      }
    }
  },
  en: {
    hero: {
      title: 'About',
      subtitle: 'Cortex AI',
      description: 'Empowering careers, building businesses, and transforming learning through AI mentorship.'
    },
    welcome: {
      title: 'Welcome to Cortex AI',
      subtitle: 'The world\'s first AI-powered mentorship platform',
      description: 'At Cortex AI, we believe learning should be more than just watching videos or reading theory—it should feel like real work experience, preparing you for real job roles and business success.',
      features: [
        'AI-powered professional mentoring – Learn directly from an interactive AI mentor that guides you like a real boss or coach.',
        'Real-world challenges and decision-making scenarios – Gain practical experience through AI-powered simulations of real work situations.',
        'Business creation support – From startup ideas to e-commerce stores, our AI mentor helps entrepreneurs launch and scale businesses.',
        'Gamified and interactive learning – No more boring courses! Earn XP, badges, and real-world achievements as you progress.'
      ]
    },
    mission: {
      title: 'Our Mission',
      subtitle: 'Bridging the gap between learning and real-world success',
      features: [
        {
          title: 'Personalized AI Mentoring',
          description: 'Learn directly from an interactive AI mentor that guides you like a real boss or coach.'
        },
        {
          title: 'Real-World Challenges',
          description: 'Face real-world challenges and scenarios that replicate authentic work situations in your professional field or entrepreneurship.'
        },
        {
          title: 'Detailed Feedback',
          description: 'Receive detailed analysis of your performance with specific recommendations to improve your professional and business skills.'
        }
      ]
    },
    founder: {
      title: 'Meet the Founder and CEO',
      name: 'Alexis Zamora',
      role: 'Founder and CEO',
      description: 'Alexis Zamora, the Founder and CEO of Cortex AI, is a visionary leader in AI-powered education and business innovation.',
      experience: 'With over 15 years of experience in IT operations, cloud computing, AI automation, and business process development, Alexis has led multimillion-dollar projects in sectors such as insurance, banking, government, and asset management.',
      vision: {
        title: 'Why was Cortex AI created?',
        description: 'Alexis saw a significant problem in the education and professional training industry:',
        problems: [
          'Online courses teach theory but don\'t prepare people for real jobs.',
          'Entrepreneurs lack step-by-step guidance on how to launch and scale a business.',
          'Job seekers struggle to get real-world experience to land well-paying roles.'
        ]
      },
      quote: '"I wanted to build a platform where people don\'t just learn, but actually experience what it\'s like to be a Product Manager, an Entrepreneur, or a Business Owner. Cortex AI provides real-world mentorship at scale, making professional growth more accessible to everyone."'
    },
    contact: {
      title: 'Contact Us',
      sections: {
        support: {
          title: 'Support',
          email: 'support@cortex-ai.com',
          phone: '+34 91 123 45 67'
        },
        sales: {
          title: 'Sales',
          email: 'sales@cortex-ai.com',
          phone: '+34 91 123 45 68'
        },
        press: {
          title: 'Press',
          email: 'press@cortex-ai.com',
          phone: '+34 91 123 45 69'
        },
        headquarters: {
          title: 'Headquarters',
          address: ['Gran Via Street, 28', '28013 Madrid, Spain']
        }
      }
    },
    locations: {
      title: 'Locations',
      offices: {
        madrid: {
          city: 'Madrid',
          address: ['Gran Via Street, 28', '28013 Madrid, Spain']
        },
        barcelona: {
          city: 'Barcelona',
          address: ['Passeig de Gracia, 43', '08007 Barcelona, Spain']
        },
        valencia: {
          city: 'Valencia',
          address: ['Colon Street, 22', '46004 Valencia, Spain']
        },
        sevilla: {
          city: 'Seville',
          address: ['Constitution Avenue, 15', '41004 Seville, Spain']
        }
      }
    },
    cta: {
      title: 'Ready to transform your career?',
      subtitle: 'Start your journey with Cortex AI today.',
      buttons: {
        start: 'Start for free',
        sales: 'Contact sales'
      }
    }
  }
};